import PartnerProfilePage from '@components/PartnerProfilePage';
import {
  getPartnerProfileServerSideProps,
  PartnerProfilePageContext,
} from '@utils/partnerProfilePage.server';

export async function getServerSideProps(ctx: PartnerProfilePageContext) {
  return getPartnerProfileServerSideProps(ctx);
}

export default PartnerProfilePage;
